import * as React from "react";
import { useTranslation } from "react-i18next";
import { DocumentTitle, PageHeader, Spinner } from "components/common";
import withParams from "routing/withParams";
import { Col, Row } from "components/bootstrap";
import ForwarderDocs from "forwarder/util/ForwarderDocs";
import LicenseCheck from "license/LicenseCheck";
import { LICENSE_SUBJECTS } from "license/constants";
import ForwarderInputProfile from "./forwarders/ForwarderInputProfile";
import { ForwardersActions } from "./stores/ForwardersStore";
import ForwarderDetailsComponent from "./forwarders/ForwarderDetailsComponent";
import SingleForwarderProvider from "./forwarders/SingleForwarderProvider";
import ForwardersContext from "./forwarders/ForwardersContext";
import withIsPermitted from "./util/withIsPermitted";
import ForwarderPageNavigation from "./ForwarderPageNavigation";
const requiredPermissions = ({ params }) => [
  `forwarders:read:${params.forwarderId}`,
  "inputprofiles:read",
  "forwarderinputs:read"
];
const ForwarderPage = ({ params }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const _handleInputProfileSwitch = (forwarder) => (nextInputProfileId) => {
    const updatedForwarder = {
      input_profile_id: nextInputProfileId,
      title: forwarder.title,
      description: forwarder.description
    };
    ForwardersActions.update(forwarder.id, updatedForwarder).then(() => {
      ForwardersActions.get(params.forwarderId);
    });
  };
  return /* @__PURE__ */ React.createElement(SingleForwarderProvider, { forwarderId: params.forwarderId }, /* @__PURE__ */ React.createElement(ForwardersContext.Consumer, null, ({ forwarders }) => {
    const forwarder = forwarders[0];
    if (!forwarder) {
      return /* @__PURE__ */ React.createElement(Spinner, null);
    }
    return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("forwarder_page.title", { title: forwarder.title }) }, /* @__PURE__ */ React.createElement(ForwarderPageNavigation, null), /* @__PURE__ */ React.createElement(
      PageHeader,
      {
        title: t("forwarder_page.title", { title: forwarder.title }),
        documentationLink: {
          title: t("common.input_profile_documentation"),
          path: ForwarderDocs.INPUT_PROFILE
        }
      },
      /* @__PURE__ */ React.createElement("span", null, t("forwarder_page.description", { title: forwarder.title }))
    ), /* @__PURE__ */ React.createElement(
      LicenseCheck,
      {
        licenseSubject: LICENSE_SUBJECTS.forwarder,
        displayWarningContainer: true,
        featureName: "Forwarder",
        bsStyle: "danger"
      }
    ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(ForwarderDetailsComponent, { forwarder, onUpdate: () => {
    } })), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      ForwarderInputProfile,
      {
        forwarder,
        inputProfileId: forwarder.input_profile_id,
        onInputProfileSwitch: _handleInputProfileSwitch(forwarder)
      }
    ))));
  }));
};
export default withParams(withIsPermitted(ForwarderPage, requiredPermissions));
